"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSessionData = exports.default = void 0;
var _react = require("react");
var _useScripts = require("./useScripts");
var _urls = require("../utilities/urls");
const TIMEOUT_INTERVAL = 500;
let extendSessionTimer;
let extendEventName = 'mousedown';
if ('ontouchstart' in document.documentElement) {
  extendEventName = 'touchstart';
}
const useScriptsList = {
  scriptsList: [{
    src: `${_urls.apiGatewayUrl}/accessmngapi/provider/accessmanagement.js`,
    isWaitUntilLoaded: false,
    checkIfAlreadyLoaded: () => window.cet && window.cet.accessmanagement
  }]
};
const useSessionData = () => {
  const {
    isReady,
    error
  } = (0, _useScripts.useScripts)(useScriptsList);
  const [sessionData, setSessionData] = (0, _react.useState)({
    isSessionDataReady: false
  });
  (0, _react.useEffect)(() => {
    let isActive = true;
    let isListening = false;
    const getSessionData = () => {
      if (isActive && window.cet && window.cet.accessmanagement) {
        window.cet.accessmanagement.getSessionAsync().then(sessionData => {
          if (isActive) {
            setSessionData(sessionData ? {
              ...sessionData,
              isSessionDataReady: true
            } : {
              isSessionDataReady: true
            });
          }
        });
      }
    };
    const extendSession = () => {
      window.clearTimeout(extendSessionTimer);
      extendSessionTimer = setTimeout(() => {
        window.cet.accessmanagement.extendSessionAsync();
      }, TIMEOUT_INTERVAL);
    };
    if (isReady && !error) {
      isListening = true;
      document.addEventListener('cet.accessmanagement.login', getSessionData);
      document.addEventListener('cet.accessmanagement.logout', getSessionData);
      document.addEventListener('cet.accessmanagement.sessionchange', getSessionData);
      window.addEventListener(extendEventName, extendSession);
      // window.addEventListener('resize', extendSession, {passive: true});

      getSessionData();
    }
    return () => {
      isActive = false;
      if (isListening) {
        document.removeEventListener('cet.accessmanagement.login', getSessionData);
        document.removeEventListener('cet.accessmanagement.logout', getSessionData);
        document.removeEventListener('cet.accessmanagement.sessionchange', getSessionData);
        window.removeEventListener(extendEventName, extendSession);
        // window.removeEventListener('resize', extendSession);
      }
    };
  }, [isReady, error]);
  return sessionData;
};
exports.useSessionData = useSessionData;
var _default = exports.default = useSessionData;